import styled from 'styled-components';

import { maxWidthContent } from '../../../utils/maxWidthContent';

interface IContentProps {
  themeType: 'light' | 'dark';
}

export const Container = styled.main<IContentProps>`
  position: relative;
  grid-area: 2 / 2 / 2 / 2;
  width: 100%;
  height: 100%;
  padding: 2.35rem 1rem 2rem 1rem;
  overflow-y: scroll;
  overflow-x: hidden;

  border-left: ${themeType => (themeType.themeType === 'dark' ? '1px solid' : 'none')};
  border-top: ${themeType => (themeType.themeType === 'dark' ? '1px solid' : 'none')}; 
  border-color: ${themeType => (themeType.themeType === 'dark' ? '#c3b8b817' : '#1fb3971f')};
  border-radius: 32px 0 0 0;
  border-right: none;
  border-bottom: none;
  background: ${themeType => (themeType.themeType === 'dark' ? '#101426' : '#ffffff')} !important;

  ::-webkit-scrollbar {
    width: 8px;
    width: 22px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 0px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const InnerContainer = styled.section`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const Center = styled.section`
  position: relative;
  max-width: ${maxWidthContent};
  width: 100%;
  margin: 0 auto;
`;
